

















import { computed, defineComponent } from '@vue/composition-api';
import { getWhiteOrBlackByContrast, normalizePotentialHexString } from '@front-app/util/color';

const DEFAULT_COLOR = '#ffffff';

export default defineComponent({
	props: {
		videoUrl: {
			type: String,
			required: true,
		},
		buttonColor: {
			type: String,
			default: DEFAULT_COLOR,
		},
	},
	setup(props) {
		const bgColor = computed(() => normalizePotentialHexString(props.buttonColor, DEFAULT_COLOR));
		const color = computed(() => getWhiteOrBlackByContrast(bgColor.value));
		return {
			bgColor,
			color,
		};
	},
});
